const NAMED_RATIOS: [number, number][] = [
  [1, 1],
  [4, 5],
  [5, 4],
  [9, 16],
  [16, 9],
  [3, 2],
  [2, 3],
  [4, 3],
  [3, 4],
  [3, 1],
]

const TOLERANCE = 0.03

/** A short aspect-ratio label for a picture, e.g. "16:9" or "4:5"; null without dimensions. */
export function aspectLabel(width: number | null, height: number | null): string | null {
  if (!width || !height) return null
  const ratio = width / height
  if (Math.abs(ratio / 1.91 - 1) <= TOLERANCE) return '1.91:1'
  for (const [w, h] of NAMED_RATIOS) {
    if (Math.abs(ratio / (w / h) - 1) <= TOLERANCE) return `${w}:${h}`
  }
  return `${width}×${height}`
}
